import { history } from '../../helpers';
import { userConstants } from '../../store/actionTypes';
import { alertActions } from './';
import { countriesAPIs, userAPIs } from '../../api';
import { TokenService, UserService } from '../../services/storage.service';
import Tracking from '../../services/tracking.service';
import { WEB_URL } from '../../api/URLs';
// import mixpanel from 'mixpanel-browser';

function register(user) {
    let payload = user;
    return async dispatch => {
        try {
            dispatch(updateLoaderState(true));
            const response = await userAPIs.registeration(payload);
            dispatch(updateLoaderState(false));
            if (response.data.original.access_token) {
                TokenService.saveToken(response.data.original.access_token)
                UserService.saveUser(response.data.original)
                dispatch(setUserDetails(response.data.original));
                const registrationDate = new Date(response.data.original.created_at);
                // Mixpanel Tracking Code Start
                Tracking.setUserForTracking(registrationDate.toISOString(), response.data.original.id)
                // Mixpanel Tracking Code End
                dispatch(alertActions.success('Thank you, Registration Successful'));
                localStorage.removeItem('refferalcode');
                dispatch(changeLoginResponse(1));
                return true
            }
            else if (response.data.error) {
                dispatch(updateLoaderState(false));
                dispatch(showServerErrors(response.data));
                return false
            }
        }
        catch (error) {
            dispatch(updateLoaderState(false));
            const errorMessage = error.response ? error.response.data.message : error.message;
            dispatch(alertActions.error(errorMessage));
            return false;
        }
    };
}

function login(username, password) {
    let payload = {
        email: username,
        password: password
    }
    return async dispatch => {
        try {
            const response = await userAPIs.login(payload);
            dispatch(updateLoaderState(false));
            if (response.data.original) {
                if (response.data.original.access_token) {
                    TokenService.saveToken(response.data.original.access_token)
                    UserService.saveUser(response.data.original)
                    Tracking.startUserTracking(response.data.original.id)

                    dispatch(setUserDetails(response.data.original));
                    // loginView('E-mail');
                    dispatch(alertActions.success("Login Successful!"));
                    dispatch(changeLoginResponse(1));
                    return;
                }
                else if (response.data.original.verifyuser) {
                    dispatch(alertActions.error(username + '|' + 'verify'));
                }
                else {
                    dispatch(alertActions.error(response.data.original.error.toString()));
                }
            }

        } catch (error) {
            const errorMessage = error.response ? error.response.data.message : error.message;
            dispatch(alertActions.error(errorMessage))
        }
    };
}

function logout() {
    return dispatch => {
        
        dispatch(logoutUser());
        dispatch(updateLoaderState(false));
        dispatch(alertActions.success("Logout Successful!"));
        
        TokenService.removeToken();
        UserService.removeUser();
        Tracking.resetUserTracking();
        
        window.location.href = '/';
        // history.go();
    }
}

function resendVerificationEmail(email) {
    let payload = {
        email: email
    }

    return async dispatch => {
        dispatch(request({ email }));
        try {
            const response = await userAPIs.resendVerificationEmail(payload)
            if (response.data.message) {
                dispatch(success(response.data.message.toString()));
                dispatch(alertActions.success(response.data.message.toString()));
            }
        } catch (error) {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
        }
    };

    function request(email) { return { type: userConstants.LOGIN_REQUEST, email } }
    function success(email) { return { type: userConstants.LOGIN_SUCCESS, email } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function verifyUserAccount(token) {
    return async dispatch => {
        try {
            const response = await userAPIs.accountVerification(token)
            if (response.data.original && response.data.original.access_token) {
                TokenService.saveToken(response.data.original.access_token)
                UserService.saveUser(response.data.original)
                dispatch(setUserDetails(response.data.original));
                dispatch(alertActions.success("Your email address has been verified."));
                window.location.href = '/';
                return;
            }
            else if (response.data && response.data.error) {
                dispatch(alertActions.error(response.data.error.toString()));
                window.location.href = '/';
                return;
            } else {
                window.location.href = '/';
                return;
            }
        } catch (error) {
            const errorMessage = error.response ? error.response.data.message : error.message;
            dispatch(alertActions.error(errorMessage));
            return false;
        }
    };
}

function forgotPassword(email) {
    let payload = {
        email: email
    }
    return async dispatch => {
        dispatch(request(email));
        try {
            const response = await userAPIs.forgotPassword(payload);
            if (response.data.success) {
                dispatch(success(response.data));
                dispatch(alertActions.success(response.data.success.toString()));
                window.location.href = '/login';
                return
            }
            else if (response.data.error) {
                dispatch(failure(response.data.error.toString()));
                dispatch(alertActions.error(response.data.error.toString()));
                window.location.href = WEB_URL.FORGOT_PASSWORD;
                return
            }
            else if (response.data.message) {
                dispatch(failure(response.data.message.toString()));
                dispatch(alertActions.error(response.data.message.toString()));
                window.location.href = WEB_URL.FORGOT_PASSWORD;
                return
            }
        } catch (error) {
            const errorMessage = error.response ? error.response.data.message : error.message;
            dispatch(alertActions.error(errorMessage));
        }
    };

    function request(email) { return { type: userConstants.FORGOTPASSWORD_REQUEST, email } }
    function success(email) { return { type: userConstants.FORGOTPASSWORD_SUCCESS, email } }
    function failure(error) { return { type: userConstants.FORGOTPASSWORD_FAILURE, error } }
}

function validatePasswordResetToken(token) {
    let payload = {
        token: token
    }
    return async dispatch => {
        dispatch(request(token));
        try {
            const response = await userAPIs.validatePasswordToken(payload, token)
            dispatch(updateLoaderState(false));
            if (response.data.success) {
                dispatch(success(response.data));
                dispatch(alertActions.success(response.data.success.toString()));
            }
            else if (response.data.error) {
                dispatch(failure(response.data.error.toString()));
                dispatch(alertActions.error(response.data.error.toString()));
                window.location.href = '/';
            }
            else if (response.data.message) {
                dispatch(failure(response.data.message.toString()));
                dispatch(alertActions.error(response.data.message.toString()));
                window.location.href = '/';
            }
        } catch (error) {
            const errorMessage = error.response ? error.response.data.message : error.message;
            dispatch(alertActions.error(errorMessage));
        }
    };

    function request(token) { return { type: userConstants.FORGOTPASSWORD_REQUEST, token } }
    function success(token) { return { type: userConstants.FORGOTPASSWORD_SUCCESS, token } }
    function failure(error) { return { type: userConstants.FORGOTPASSWORD_FAILURE, error } }
}

function passwordReset(payload) {

    return async dispatch => {
        dispatch(request(payload));
        dispatch(updateLoaderState(true));
        try {
            const response = await userAPIs.resetPassword(payload);
            dispatch(updateLoaderState(false));

            if (response.data.error) {
                dispatch(failure(response.data.error.toString()));
                dispatch(alertActions.error(response.data.error.toString()));
                window.location.href = '/login';
            }
            else if (response.data.message) {
                dispatch(failure(response.data.message.toString()));
                dispatch(alertActions.error(response.data.message.toString()));
                window.location.href = '/login';
            }
            else if (response.data.success) {
                dispatch(success(response.data));
                dispatch(alertActions.success(response.data.success.toString()));
                window.location.href = '/login';
            }
        }
        catch (error) {
            dispatch(updateLoaderState(false));
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.response ? error.response.data.message : error.message));
        }
    };

    function request(payload) { return { type: userConstants.FORGOTPASSWORD_REQUEST, payload } }
    function success(payload) { return { type: userConstants.FORGOTPASSWORD_SUCCESS, payload } }
    function failure(error) { return { type: userConstants.FORGOTPASSWORD_FAILURE, error } }
}

function validateToken() {
    return async dispatch => {
        try {
            const response = await userAPIs.validateToken();
            if (response.data.error) {
                TokenService.removeToken();
                UserService.removeUser();
                window.location.href = '/login';
            }
        } catch (error) {
            TokenService.removeToken();
            UserService.removeUser();
            window.location.href = '/login';
        }
    };
}

function checkEmailExist(email) {
    let payload = {
        email: email
    }
    return async dispatch => {
        try {
            const response = await userAPIs.checkEmailExists(payload)
            if (response.data.success) {
                return false
            }
            else if (response.data.error) { 
                return true
            }
        } catch {
            dispatch(alertActions.error('Something went wrong, Please try later'));
            return false
        }
    };
}

function getCities(country_id) {

    return async dispatch => {
        try {
            const response = await countriesAPIs.getCitiesByCountry(country_id);
            dispatch(changeCitiesList(response.data.data));
        } catch (error) {
            return false
        }
    };
}

function getCountryStates(country_id) {
    return async dispatch => {
        try {
            const response = await countriesAPIs.getCountryStates(country_id)
            dispatch(changeCountryStatesList(response.data.data));
        }
        catch (error) {
            dispatch(alertActions.error(error.response ? error.response.data.message : error.message));
            return false
        }
    };
}

function checkAllowedCountryForCheque(donor_country_id, currency_country_id) {
    return async dispatch => {
        try {
            const response = await countriesAPIs.chequeAllowedCountry(donor_country_id, currency_country_id);
            dispatch(updateAllowedCountryForCheque(response.data.data));
        }
        catch {
            return false;
        }
    };
}

function getGiftAidCountryStates(country_id) {
    return async dispatch => {
        try {
            const response = await countriesAPIs.getCountryStates(country_id);
            dispatch(changeGiftAidCountryStatesList(response.data.data));
        }
        catch {
            return false
        }
    };
}

// function getCitiesGiftAid(country_id) {
//     return dispatch => {
//         let apiEndpoint = 'api/cities/' + country_id;
//         userService.get(apiEndpoint)
//             .then((response) => {
//                 dispatch(changeGiftAidCitiesList(response.data.data));
//             }).catch((err) => {
//                 return false
//             })
//     };
// }

function getPrivacyPolicy(policy_id, type = "privacy") {
    let url = "https://www.iubenda.com/api/privacy-policy/" + policy_id;
    if (type === "privacy") {
        url = "https://www.iubenda.com/api/privacy-policy/" + policy_id;
    } else if (type === "cookie") {
        url = "https://www.iubenda.com/api/privacy-policy/" + policy_id + "/cookie-policy";
    }
    return dispatch => {
        var axios = require('axios');

        return axios.get(url)
            .then((response) => {
                dispatch(updatePrivacyPolicy(response.data.content));
            }).catch((err) => {
                return false
            })
    };
}

export function setUserDetails(user) {
    return {
        type: "LOGIN_SUCCESS",
        auth: 'authenticate',
        token: user.access_token,
        role_id: user.role_id,
        user: user
    }
}

export function logoutUser() {
    return {
        type: "LOGOUT_SUCCESS",
        auth: false,
        token: ''
    }
}

export function updateLoaderState(loader_state) {
    return {
        type: "UPDATE_LOADER_STATE",
        loader_state: loader_state
    }
}

export function changeLoginResponse(login_result) {
    return {
        type: "LOGIN_RESPONSE",
        login_result: login_result
    }
}

export function showServerErrors(server_errors) {
    return {
        type: "SERVER_ERRORS",
        server_errors: server_errors
    }
}

export function changeCitiesList(cities_list) {
    return {
        type: "CITIES_LIST",
        cities_list: cities_list
    }
}

export function changeCountryStatesList(country_states_list) {
    return {
        type: "COUNTRY_STATES_LIST",
        country_states_list: country_states_list
    }
}

export function updateAllowedCountryForCheque(allowed_country_for_cheque) {
    return {
        type: "ALLOWED_COUNTRY_FOR_CHEQUE",
        allowed_country_for_cheque: allowed_country_for_cheque
    }
}

export function changeGiftAidCountryStatesList(country_states_list) {
    return {
        type: "GIFTAID_COUNTRY_STATES_LIST",
        giftaid_country_states_list: country_states_list
    }
}

export function changeGiftAidCitiesList(cities_list) {
    return {
        type: "GIFTAID_CITIES_LIST",
        giftaid_cities_list: cities_list
    }
}

export function updatePrivacyPolicy(update_privacy_policy) {
    return {
        type: "UPDATE_PRIVACY_POLICY",
        update_privacy_policy: update_privacy_policy
    }
}

export function updateLoginCreds(user, token) {
    return {
        auth: "user",
        token: token
    }
}

export const userActions = {
    login,
    logout,
    register,
    resendVerificationEmail,
    forgotPassword,
    validatePasswordResetToken,
    passwordReset,
    validateToken,
    updateLoaderState,
    verifyUserAccount,
    checkEmailExist,
    getCities,
    getCountryStates,
    // getCitiesGiftAid,
    getGiftAidCountryStates,
    getPrivacyPolicy,
    checkAllowedCountryForCheque
};